export default function Description({ description }) {
  return <div className="description">{description}</div>
}
